// import { getXFeatureAccess } from "src/Shared/Utils/LocalStorageUtils";
import { ConfigModel } from '../Model';
import { getEnvConfigKey } from './environment.utils';

const ENV_CONFIG_URL =
  'https://dev-rms-config-294f655d18b3.s3.ap-south-1.amazonaws.com/external-config.json';

const loadConfig = (): ConfigModel => {
  try {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', ENV_CONFIG_URL, false);
    xhr.send(null);

    if (xhr.status === 200) {
      const data = JSON.parse(xhr.responseText);
      return getEnvConfigKey(data);
    } else {
      console.error(`Failed to load configuration. Status: ${xhr.status}`);
      return require('./Prod.json');
    }
  } catch (error) {
    return require('./Prod.json');
  }
};

export const getConfig = () => {
  // let xValue = getXFeatureAccess();
  const Config: ConfigModel = loadConfig();
  return function () {
    // let xFeature = getXFeatureAccess();
    // if (xValue !== xFeature) {
    //     xValue = xFeature;
    //     Config = loadConfig(xFeature);
    // }
    return Config;
  };
};
export const ConfigProvider = getConfig();
export default ConfigProvider;
